export function SceneAtmosphere({ flickTrigger }) {
  return (
    <>
      <div className="bezel" />
      <div id="atmos">
        <div className="grain" />
        <div className="scan" />
        <div key={flickTrigger} className="flick flick-burst" />
        <div className="vig" />
      </div>
    </>
  )
}
